import NotificationsIcon from '@mui/icons-material/Notifications';
import Badge from '@mui/material/Badge';
import { Avatar, LinearProgress, ListItem } from '@mui/material';
import { useEffect, useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Settings from '@mui/icons-material/Settings';
import { useNavigate } from 'react-router-dom';
import ListItemIcon from '@mui/material/ListItemIcon';
import Logout from '@mui/icons-material/Logout';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
export default function Notifications({
    LogOut,
    addr,
    mainVersion,
    initPhase2,
    clientId,
    sessionId,
    isDarkMode,
    setIsDarkMode
}) {
    const navigate = useNavigate()
    const [anchorE1, setAnchorE1] = useState(null)
    const [anchorE2, setAnchorE2] = useState(null)
    const [notifications, setNotifications] = useState([]);
    const [notificationNumber, setNotificationNumber] = useState(0)
    const [emptyNotifications, setEmptyNotifications] = useState(true)
    
    const [showDarkThemeLoader, setShowDarkThemeLoader] = useState(false);
    
    function openDarkTheme() {
        
      setShowDarkThemeLoader(true)
  const timer = setTimeout(()=>{
      setShowDarkThemeLoader(false)
  }, 1000)
  return ()=>clearTimeout(timer)
  }
    const toggleDarkMode = (checked) => {
      openDarkTheme();
        setIsDarkMode(!checked)
    };
    async function initPhase() {
        if(clientId && sessionId) {
          
          try {
            const endpoint = `${addr}:7070`
            const agent = window.navigator.userAgent;
            const message = {
              type: 'notifications',
              version: mainVersion,
              clientId,
              sessionId,
              agent
            }
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(message)
            });
  
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
  
            // If you need to handle the response
            const responseData = await response.json();
            if(responseData.type === 'empty') {
                setEmptyNotifications(true)
            }
            if(responseData.type === 'success') {
                console.log(responseData)
                setEmptyNotifications(false)
                setNotifications(responseData.notifications)
            } 
          } catch (error) {
            console.error('Error:', error);
          }
        }
      }
      async function initPhase3(id) {
          if(clientId && sessionId) {
            
            try {
              const endpoint = `${addr}:7070`
              const agent = window.navigator.userAgent;
              const message = {
                type: 'notification-delete',
                id,
                version: mainVersion,
                clientId,
                sessionId,
                agent
              }
              const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(message)
              });
    
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
    
              // If you need to handle the response
              const responseData = await response.json();
              if(responseData.type === 'empty') {
                  setEmptyNotifications(true)
                  setNotifications([])
              }
              if(responseData.type === 'success') {
                  console.log(responseData)
                  initPhase2()
                  setEmptyNotifications(false)
                  setNotifications(responseData.notifications)
              } 
            } catch (error) {
              console.error('Error:', error);
            }
          }
        }
      
      async function readNotifications() {
        setNotificationNumber(0)
        if(clientId && sessionId) {
          
          try {
            const endpoint = `${addr}:7070`
            const agent = window.navigator.userAgent;
            const message = {
              type: 'read-notifications',
              version: mainVersion,
              clientId,
              sessionId,
              agent
            }
            const response = await fetch(endpoint, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(message)
            });
  
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
          } catch (error) {
            console.error('Error:', error);
          }
        }
      }
    useEffect(()=>{
        let num = 0
        notifications.forEach((notification)=>{
            if(notification.viewed === 0) {
                num++
            }
        })
        setNotificationNumber(num)
    }, [notifications])
    useEffect(()=>{
        const notificationsFetch = setInterval(()=>{
              initPhase()
              return () => clearInterval(notificationsFetch)
        }, 30000)
        
        initPhase()
    }, [clientId])


    const openUser = Boolean(anchorE1);
    const openNoti = Boolean(anchorE2);
    const handleUserClick = (event) => {
        setAnchorE1(event.currentTarget);
        setAnchorE2(null)
    };
    const handleClickNotification = (event) => {
        initPhase()
        readNotifications()
        setAnchorE2(event.currentTarget);
        setAnchorE1(null)
    };
    
  
  const handleClose = () => {
    setAnchorE1(null);
    setAnchorE2(null);
  };
    return (
    
    <>

        {/**User Button */}

        <div style={{
            position: 'fixed',
            top: 16,
            right: 24,
            zIndex: 3001
        }}>
            <md-icon-button aria-label='Profile' color="#ff0000" onClick={handleUserClick}>
                    <Avatar size='small'/>
            </md-icon-button>
        </div>
        <Menu
        id="user-button"
        anchorEl={anchorE1}
        open={openUser}
        onClose={handleClose}
        PaperProps={{
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem onClick={LogOut}>
                
                <ListItemIcon>
                    <Logout fontSize="small" />
                </ListItemIcon>
                Logout
            </MenuItem>
            <MenuItem onClick={()=>{toggleDarkMode(isDarkMode)}}>
                <ListItemIcon>
                    <DarkModeSwitch
                    checked={!isDarkMode}
                    moonColor='black'
                    sunColor='white'
                    size={25}
                    />
                </ListItemIcon>
                {isDarkMode ? 'Light mode' : 'Dark mode'}
            </MenuItem>
        </Menu>


        {/**Notification Button */}
        <div style={{
            position: 'fixed',
            top: 17,
            right: 80,
            zIndex: 3001
        }}>
            <md-icon-button aria-label='Notifications' color="#ff0000" onClick={handleClickNotification}>
                <Badge badgeContent={notificationNumber} color='primary'>
                    <NotificationsIcon />
                </Badge>
            </md-icon-button>
        </div>
        
        <Menu
        id="noti-button"
        anchorEl={anchorE2}
        open={openNoti}
        onClose={handleClose}
        PaperProps={{
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            {emptyNotifications ? <MenuItem>You have no notifications!</MenuItem>:
            <>{notifications.map((notification) => (
                <>
                    <ListItem sx={{width: 300, padding: 1, textWrap: 'wrap'}} >
                        <div style={{
                            display: 'flex',
                            paddingBottom: 5,
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: 5,
                            borderBottom: '1px solid var(--md-sys-color-primary)'
                        }}>
                         <span>
                            {(JSON.parse(notification.action).type === 'note' && <><svg xmlns="http://www.w3.org/2000/svg" height="30" viewBox="0 -960 960 960" width="30" fill="var(--md-sys-color-primary)"><path d="M200-200h360v-200h200v-360H200v560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v400L600-120H200Zm80-280v-80h200v80H280Zm0-160v-80h400v80H280Zm-80 360v-560 560Z"/></svg></>)}
                         </span>
                         {notification.message}
                         <md-text-button onClick={()=>{
                            const noteId = JSON.parse(notification.action).noteId
                            
                            initPhase3(notification.id)
                            navigate(`/editor/${noteId}`)
                            handleClose()
                         }}>
                            {(JSON.parse(notification.action).type === 'note' && <>Open Note</>)}
                         </md-text-button>
                        </div>
                    </ListItem>
                </>
            ))}</>}
        </Menu>
        
        {showDarkThemeLoader && 
        <div class="loading-overlay">
            Switching theme...
            <div style={{
                width: 300,
                height: 20,
                marginTOp: 100
            }}>
                
                <LinearProgress />
            </div>
        </div>}
    </>
    )
}